export default {
  msAccount: null
  // accessToken: null,
  // userData: null
}